<template>
  <CalicoOnboarding
    :loading="loading"
    :form-data="formData"
    @save="save"
  >
    <div class="web-and-socials">
      <CalicoForm
        v-slot="{ field, error }"
        name="website"
        label="Website"
        rules="website"
      >
        <CalicoField 
          v-model="formData.website" 
          v-bind="field"
          :error="error"
          maxlength="200"
          placeholder="https://www.example.com"
        />
      </CalicoForm>
      <CalicoForm
        v-slot="{ field, error }"
        name="linkedin"
        label="LinkedIn"
        rules="linkedin"
      >
        <CalicoField 
          v-model="formData.linkedin"
          v-bind="field"
          :error="error"
          maxlength="80"
          placeholder="https://www.linkedin.com/in/yourname"
        />
      </CalicoForm>
      <CalicoForm
        v-slot="{ field, error }"
        name="facebook"
        label="Facebook"
        rules="facebook"
      >
        <CalicoField
          v-model="formData.facebook"
          v-bind="field"
          :error="error"
          maxlength="80"
          placeholder="https://www.facebook.com/yourpage"
        />
      </CalicoForm>
      <CalicoForm
        v-slot="{ field, error }"
        name="instagram"
        label="Instagram"
        rules="instagram"
      >
        <CalicoField
          v-model="formData.instagram"
          v-bind="field" 
          :error="error"
          maxlength="80"
          placeholder="https://www.instagram.com/yourhandle"
        />
      </CalicoForm>
      <CalicoForm
        v-slot="{ field, error }"
        name="other"
        label="Other"
        rules="url"
      >
        <CalicoField
          v-model="formData.other_socials"
          v-bind="field" 
          :error="error"
          maxlength="80"
          placeholder="https://yourplatform.com/profile"
        />
      </CalicoForm>
    </div>
  </CalicoOnboarding>
</template>

<script>
import CalicoOnboarding from "@/components/template/onboarding/index.vue";
import CalicoForm from "@/components/pattern/form/index.vue"
import CalicoField from '@/components/calico/field/index.vue'
import services from "@/services";

export default {
  name: 'WebAndSocialsScreen',
  components: {
    CalicoOnboarding,
    CalicoField,
    CalicoForm,
  },
  data() {
    return {
      formData: {
        website: "",
        facebook: "",
        instagram: "",
        linkedin: "",
        other_socials: "",
      },
      business: {},
      loading: true
    }
  },
  async mounted() {
    this.business = await services.user.business.get()
    this.formData = {
      website: this.business.website,
      facebook: this.business.facebook,
      instagram: this.business.instagram,
      linkedin: this.business.linkedin,
      other_socials: this.business.other_socials,
    };
    this.loading = false
  },
  methods: {
    normalizeUrl(value) {
      if (!value) return null;
      let stripped = value.replace(/^(https?:\/\/)?(www\.)?/, '');
      return `https://www.${stripped}`;
    },
    async save(next) {
      await services.user.business.save({
        website: this.normalizeUrl(this.formData.website),
        facebook: this.normalizeUrl(this.formData.facebook),
        instagram: this.normalizeUrl(this.formData.instagram),
        linkedin: this.normalizeUrl(this.formData.linkedin),
        other_socials: this.normalizeUrl(this.formData.other_socials),
      })
      next()
    }
  }
}
</script>

<style scoped lang="scss">
.web-and-socials {
  @include stack-space($space-large);
  padding: $space-large;
}
</style>